/**
 * @file: applyOrderFacadeItemResult.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { applyFacadeItemResult } from '@euler/functions/inventory/applyFacadeItemResult';
import { InspectionSiteInfo } from '@euler/model';
import { OptionValueType } from '@euler/model/enum';
import { SiteInspectionItemStaged } from '@euler/model/task-detail';

/**
 * Puts on a staged facade check item of an order draft the result derived from
 * its photos, keeping the item's result value in sync with it - which is what
 * an order carries the picked result in.
 *
 * Call it whenever the photos of the item change, since the result follows
 * them. See [[applyFacadeItemResult]].
 */
export const applyOrderFacadeItemResult = (
  item: SiteInspectionItemStaged,
  site: InspectionSiteInfo,
) => {
  const { option } = applyFacadeItemResult(item, site);

  if (item.type !== 'item') return;

  const resultDataStringValue = option?.label ?? '';

  if (
    item.result.valueType !== OptionValueType.String ||
    item.result.value !== resultDataStringValue
  ) {
    item.result = {
      valueType: OptionValueType.String,
      value: resultDataStringValue,
    };
  }
};
